import { useEffect, useRef } from "react";
import { Checkbox, Button, Card, Col, DatePicker, Form, Input, Row } from "antd";
import { t } from "i18next";
import { useDataGrid } from "../../../core/components/data-grid/DataGridContext";

export default function PatientFilter() {
    const { onFilterPageSort, queryModel } = useDataGrid();
    const formRef = useRef();

    useEffect(() => {
        formRef.current?.setFieldsValue({
            validate: true,
            ...queryModel.filter,
        });
    }, [queryModel.updateKey]);



    const onFinish = async (formData) => {
        onFilterPageSort({
            filter: formData
        })
    }

    return (
        <Form
            size="small"
            layout="inline"
            ref={formRef}
            onFinish={onFinish}
            initialValues={{
                validate: true
            }}
        >
            <Form.Item
                name="searchText"
                style={{ marginRight: 12 }}
            >
                <Input
                    placeholder={t("Name, Id, Phone ...")}
                    style={{ width: 200 }}
                />
            </Form.Item>

            <Form.Item
                name="validate"
                valuePropName="checked"
                style={{ marginRight: 12 }}
            >
                <Checkbox style={{ whiteSpace: "nowrap" }}>
                    {t("Doğrulanmış Hastalar")}
                </Checkbox>
            </Form.Item>

            <Form.Item>
                <Button htmlType={'submit'}>
                    {t("Search")}
                </Button>
            </Form.Item>
        </Form>
    )
}